module.exports = __webpack_public_path__ + "static/waltz-krem-rolls-ljesnjak-e7274cd9f4ca3747c7f36b226ae650e6.jpg";